import { getCurrentInstance } from '@/util'

export default function useRouter() {
  const instance = getCurrentInstance()
  return instance.proxy.$router
}
